<template lang="pug">
  .page-skeleton
    .ssc-line
</template>

<script>
  export default {
    name: 'PageSkeleton',
  };
</script>

<style lang="stylus">
.page-skeleton
  .ssc-line
    border-radius 0
    height 100vh
</style>

